import { render, staticRenderFns } from "./TableOrders.vue?vue&type=template&id=eec731b2&scoped=true"
import script from "./TableOrders.vue?vue&type=script&lang=js"
export * from "./TableOrders.vue?vue&type=script&lang=js"
import style0 from "./TableOrders.vue?vue&type=style&index=0&id=eec731b2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eec731b2",
  null
  
)

export default component.exports